import { render, staticRenderFns } from "./ProjectGroupListingTable.vue?vue&type=template&id=25f0ff02"
import script from "./ProjectGroupListingTable.vue?vue&type=script&lang=js"
export * from "./ProjectGroupListingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports